"use strict";

exports.__esModule = true;
exports.StyledDividerText = exports.StyledDivider = void 0;

var _stitches = require("../theme/stitches.config");

const StyledDivider = (0, _stitches.styled)('div', {
  width: '100%',
  maxWidth: '100%',
  position: 'relative',
  variants: {
    color: {
      default: {
        bg: '$border'
      },
      primary: {
        bg: '$primary'
      },
      secondary: {
        bg: '$secondary'
      },
      success: {
        bg: '$success'
      },
      warning: {
        bg: '$warning'
      },
      error: {
        bg: '$error'
      }
    }
  },
  defaultVariants: {
    color: 'default'
  }
});
exports.StyledDivider = StyledDivider;
const StyledDividerText = (0, _stitches.styled)('span', {
  position: 'absolute',
  left: '50%',
  top: '50%',
  minHeight: '100%',
  display: 'inline-flex',
  jc: 'center',
  ai: 'center',
  transform: 'translate(-50%, -50%)',
  padding: '0 $lg',
  fontSize: '$base',
  fontWeight: 'bold',
  textTransform: 'capitalize',
  backgroundColor: '$background',
  zIndex: '$1',
  variants: {
    color: {
      default: {
        color: '$text'
      },
      primary: {
        color: '$primary'
      },
      secondary: {
        color: '$secondary'
      },
      success: {
        color: '$success'
      },
      warning: {
        color: '$warning'
      },
      error: {
        color: '$error'
      }
    }
  }
});
exports.StyledDividerText = StyledDividerText;